import React, { useState } from 'react'

const useRerender = () => {
    const [val, setVal] = useState(1);

    function handleChange(){
        setVal(p=> (p+1)%5);
    }
  return ({
    renderVal: val, handleRenderChange:handleChange
  })
}

export default useRerender